import React from "react";
import { ERROR } from "../pages/allScheduling/constants";

// Textos mantidos exatamente como estavam nas telas de erro anteriores.
const MESSAGES = {
  [ERROR.CONFIG_NOT_FOUND]: "Esse evento não possui configurações",
  [ERROR.LOGIN_NOT_FOUND]:
    "Participante não cadastrado no evento, contate o suporte.",
  [ERROR.PARAMS_NOT_FOUND]: "Erro ao ler participante e/ou evento.",
};

const FALLBACK = "Não foi possível carregar seus agendamentos.";

/**
 * Mensagem de falha que ocupa o lugar do conteudo da pagina.
 *
 * @param {string} message  um dos codigos de ERROR
 */
export default function CardError({ message }) {
  return (
    <div className="sched-error" role="alert">
      <i className="bx bx-error-circle sched-error-icon" aria-hidden="true" />
      <p className="sched-error-text">{MESSAGES[message] || FALLBACK}</p>
    </div>
  );
}
